import { CostType } from '../shared/enum/CostType';

export interface MediaModel {
    id: number,
    codeMetric: number | null,
    costTypeCodeMetric:  number | null,
    mediaCredibilityUseFactor:number | null,        
    name: string,
    startOfPeriod: Date,
    endOfPeriod: Date | null,
    costType: CostType
}

export const mediaModelInitial: MediaModel = {
    id: 0,
    codeMetric: null,
    costTypeCodeMetric: null,
    mediaCredibilityUseFactor: null,        
    name: '',
    startOfPeriod: new Date(),
    endOfPeriod: null,
    costType: CostType.NONE
};